// helpers
var HELPERS = {
    required: function (val) {
        return val !== null && val !== undefined && !!"".concat(val).trim();
    },
    num: function (val) {
        return val && "".concat(val).trim() && /^\d+$/gi.test(val);
    },
    numList: function (val) {
        return val && "".concat(val).trim() && /^(\d+,?)+\d+$/gi.test(val);
    },
};
/**
 * 简单的验证
 * 传入 rules 和 formData
 * 返回验证结果和错误信息
 * @example
 * var formData = {
 *    name: 'test',
 *    index: 1
 * }
 *
 * var rules = {
 *    name: {
 *      validator: (val) => {
 *         return val && val.trim()
 *      },
 *      message: '请填写名称'
 *    },
 *    index: {
 *      validator: (val) => {
 *        return val && /^\d+$/gi,
 *      },
 *      message: '请填写正确的索引值'
 *    }
 * }
 * validate(formData, rules)
 */
export function validate(formData, rules) {
    var result = true;
    var error = '';
    var key = '';
    for (var k in rules) {
        var rule = rules[k];
        if (rule) {
            var val = formData[k];
            var validator = rule.validator;
            var _validator = typeof validator === 'string' ? HELPERS[validator] : validator;
            var r = _validator(val);
            if (!r) {
                result = false;
                error = rule.message;
                key = k;
                return [result, key, error];
            }
        }
    }
    return [result, key, error];
}
//# sourceMappingURL=validate.js.map